/* eslint-disable no-bitwise -- Pix CRC16 checksum uses bit operations. */
export const validPixAmount = value =>
  /^\d{1,7}(?:\.\d{1,2})?$/.test(String(value)) && Number(value) > 0;

export const buildPixMessagePayload = (payment, body) => {
  const fields = [
    'reference_id',
    'amount',
    'description',
    'pix_code',
    'pix_url',
    'merchant_name',
    'pix_key',
    'pix_key_type',
  ];
  const interactive = { type: 'order_details' };
  fields.forEach(field => {
    if (payment[field] !== undefined) interactive[field] = payment[field];
  });
  return {
    message: body.trim(),
    private: false,
    contentType: 'whatsapp_interactive',
    contentAttributes: { interactive },
  };
};

export const validPixCode = code => {
  if (
    typeof code !== 'string' ||
    code.length > 2048 ||
    !code.startsWith('000201') ||
    !code.includes('br.gov.bcb.pix') ||
    !/6304[0-9a-f]{4}$/i.test(code)
  )
    return false;
  const crc = Array.from(new TextEncoder().encode(code.slice(0, -4))).reduce(
    (value, byte) => {
      let checksum = value ^ (byte << 8);
      for (let bit = 0; bit < 8; bit += 1) {
        checksum =
          checksum & 0x8000
            ? ((checksum << 1) ^ 0x1021) & 0xffff
            : (checksum << 1) & 0xffff;
      }
      return checksum;
    },
    0xffff
  );
  return crc === parseInt(code.slice(-4), 16);
};
